import React from "react";
import ReactDOM from "react-dom";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

const Toast = (): React.ReactPortal => {
  return ReactDOM.createPortal(
    <ToastContainer
      autoClose={5000}
      closeOnClick
      closeButton
      position="top-center"
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="dark"
    />,
    document.getElementById("toast-root") as HTMLElement
  );
};

export default Toast;
